import { render, staticRenderFns } from "./gj-video.vue?vue&type=template&id=108043d9&scoped=true&"
import script from "./gj-video.vue?vue&type=script&lang=js&"
export * from "./gj-video.vue?vue&type=script&lang=js&"
import style0 from "./gj-video.vue?vue&type=style&index=0&id=108043d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108043d9",
  null
  
)

export default component.exports